class CartNotification extends HTMLElement {
  constructor() {
    super();

    document.addEventListener("DOMContentLoaded", () => {
      this.notification = document.getElementById("cart-notification");

      if (!this.notification) {
        console.error("❌ Cart notification element not found in the DOM.");
        return;
      }

      this.header = document.querySelector("sticky-header");
      this.onBodyClick = this.handleBodyClick.bind(this);

      this.notification.addEventListener("keyup", (evt) => {
        if (evt.code === "Escape") this.close();
      });

      this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
        closeButton.addEventListener("click", this.close.bind(this))
      );
    });
  }

  open() {
    if (!this.notification) {
      console.error("❌ Cannot open: cart notification element not found.");
      return;
    }

    this.notification.classList.add("animate", "active");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    if (!this.notification) {
      console.error("❌ Cannot close: cart notification element not found.");
      return;
    }

    this.notification.classList.remove("active");
    document.body.removeEventListener("click", this.onBodyClick);
    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.updateCartBubble(parsedState.item_count); // ✅ Now properly defined below

    this.getSectionsToRender().forEach((section) => {
      let targetElement = document.getElementById(section.id);
      if (targetElement && parsedState.sections[section.id]) {
        targetElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    });

    if (this.header && typeof this.header.reveal === "function") {
      this.header.reveal();
    }

    this.open();
  }

  updateCartBubble(cartCount) {
    console.log("🔄 Updating cart bubble count:", cartCount);
    const cartBubble = document.querySelector("#cart-icon-bubble");

    if (!cartBubble) {
      console.error("❌ Cart bubble not found!");
      return;
    }

    cartBubble.textContent = cartCount;
    cartBubble.classList.toggle("hidden", cartCount === 0);
  }

  getSectionsToRender() {
    return [
      { id: "cart-notification-product", selector: `#cart-notification-product-${this.productId}` },
      { id: "cart-notification-button" },
      { id: "cart-icon-bubble" },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return (
      new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.innerHTML || ""
    );
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest("cart-notification")) {
      const disclosure = target.closest("details-disclosure");
      this.activeElement = disclosure ? disclosure.querySelector("summary") : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

// ✅ REGISTER CUSTOM ELEMENT
customElements.define("cart-notification", CartNotification);

document.addEventListener("DOMContentLoaded", () => {
  fetch('/cart.js')
    .then(response => response.json())
    .then(data => {
      console.log("Cart data on page load:", data);
      document.querySelector("cart-notification")?.updateCartBubble(data.item_count);
    });
});
